import React from "react";
import {RouteProps} from "react-router-dom";

import {useFluxClaims} from "components/common/hooks/useFluxClaims";
import FullPageLoader from "components/common/components/loader/FullPageLoader";
import PageNotFound from "components/pages/errors/404/PageNotFound";

import ConditionalRoute from "./ConditionalRoute";

interface IFluxClaimsRouteProps extends RouteProps {
    /**
     * The flux claim required to access this route
     */
    requiredClaim: "superadmin" | "admin" | "internal";

    /**
     * If true, the route should only be available to non-anonymous fully-authenticated users
     */
    isProtected?: boolean;
}

/**
 * A route component that checks for flux claims before allowing access.
 * Shows loading state while claims are being fetched and 404 for unauthorized users.
 */
export default function FluxClaimsRoute({requiredClaim, isProtected = true, ...routeProps}: IFluxClaimsRouteProps) {
    const {claim: hasClaim, isLoading} = useFluxClaims(requiredClaim);

    if (isLoading) {
        return <FullPageLoader surface={"flux_claims_check"} showNavBar={true} />;
    }

    if (!hasClaim) {
        return <PageNotFound />;
    }

    return <ConditionalRoute isProtected={isProtected} {...routeProps} />;
}
